/**
 * Meta Pixel helper — thin wrapper around window.fbq.
 * Base code + Pixel ID 2102145283659717 is installed in public/index.html.
 * Never send PII (names/emails/phones) as event params.
 */

export const metaTrack = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', eventName, params);
  }
};

export const trackMetaLead = (formSource) =>
  metaTrack('Lead', { form_source: formSource || 'website_contact_form' });

export const trackMetaSchedule = () => metaTrack('Schedule');

export const trackMetaContact = (method) =>
  metaTrack('Contact', { contact_method: method || 'unknown' });
